import { computed, ref } from 'vue'

export const useSupportChat = () => {
  const isOpen = ref(false)
  const supportThreadId = ref<string | number | null>(null)

  const toggleChat = () => {
    isOpen.value = !isOpen.value
  }

  const isExpanded = ref(false)
  const isFull = ref(false)

  const framePosClasses = computed(() => (isFull.value ? 'inset-4' : 'bottom-[calc(2rem+30px)] right-8'))

  const frameSizeClasses = computed(() => {
    if (isFull.value) return 'w-auto h-auto'
    return isExpanded.value ? 'w-[602px] h-[570px]' : 'w-[402px] h-[370px]'
  })

  const expandIcon = computed(() =>
    isFull.value ? 'pi pi-arrow-down' : isExpanded.value ? 'pi pi-arrow-down' : 'pi pi-arrows-v'
  )

  const toggleExpand = () => {
    if (isFull.value) {
      isFull.value = false
      isExpanded.value = true
      return
    }
    isExpanded.value = !isExpanded.value
  }

  const expandFull = () => {
    isFull.value = !isFull.value
    if (isFull.value) isExpanded.value = true
  }

  return {
    isOpen,
    supportThreadId,
    toggleChat,
    isExpanded,
    isFull,
    framePosClasses,
    frameSizeClasses,
    expandIcon,
    toggleExpand,
    expandFull
  }
}
